import { render } from "./Galaxy.vue?vue&type=template&id=5dfa0463&scoped=true"
import script from "./Galaxy.vue?vue&type=script&lang=js"
export * from "./Galaxy.vue?vue&type=script&lang=js"

import "./Galaxy.vue?vue&type=style&index=0&id=5dfa0463&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5dfa0463"

export default script